<template lang="pug">
  v-form.login(ref="form" @submit.prevent="login")
    v-layout(column wrap align-center justify-center)
      v-flex.fundo-login(xs12)
      v-flex.login-position(xs12)
        img.logo-login(src="@/assets/logo.png")
        v-card.mt-2.login-card
          v-card-text
            v-text-field(
              label="CNPJ ou Login"
              :rules="inputRequired"
              :mask="mask"
              @keyup="maskFormatter"
              @input="payload.login = $event"
              required
              )
            v-text-field(
              required
              label="Senha"
              v-model="payload.password"
              :type="passwordFieldType"
              :append-icon="passwordFieldIcon"
              :append-icon-cb="togglePasswordVisibility"
              :rules="inputPassword"
              counter
              )
            v-btn(
              dark
              block
              small
              color="primary"
              type="submit"
              ) Acessar o sistema
</template>

<script>
import LoginService from '@/services/LoginService';
import EventBus from '@/core/event-bus';

export default {
  data: () => ({
    payload: {
      login: '',
      password: '',
    },
    passwordVisible: false,
    isPasswordHide: true,
    inputPassword: [v => !!v || 'Senha deve ser preenchida'],
    inputRequired: [v => !!v || 'Este campo é obrigatório'],
    mask: null,
  }),
  computed: {
    passwordFieldType() {
      return this.isPasswordHide ? 'password' : 'text';
    },
    passwordFieldIcon() {
      return this.isPasswordHide ? 'visibility' : 'visibility_off';
    },
  },
  methods: {
    maskFormatter(evt) {
      this.mask = isNaN(this.payload.login + evt.key) ? null : '##.###.###/####-##';
    },
    login() {
      if (!this.$refs.form.validate()) return;

      LoginService
        .login(this.payload)
        .then((response) => {
          LoginService.salvarUser(this.payload.login);
          LoginService.salvarToken(response.headers.authorization);
          this.$router.replace('/');
        })
        .catch((error) => {
          const { message } = error.response.data;
          EventBus.$emit('snackbar', { active: true, color: 'error', msg: message });
        });
    },
    togglePasswordVisibility() {
      this.isPasswordHide = !this.isPasswordHide;
    },
  },
};
</script>

<style lang="sass">
.login-position
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

.fundo-login
  position: absolute
  top: 0
  right: 0
  left: 0
  bottom: 50vh
  background: linear-gradient(to bottom, #0277bd 0%, #64b5f6 100%)

.logo-login
  margin-top: -228px
  width: 100%

.login-card
  width: 100%
</style>



// WEBPACK FOOTER //
// src/app/Login/Login.vue